import {useEffect} from 'react';

const listenersMap = {};

export const listenerMiddleware = () => next => action => {
  const listeners = listenersMap[action.type] || [];
  listeners.forEach(listener => {
    listener(action);
  });
  return next(action);
};
const removeListenerFactory = (type, listener) => () => {
  listenersMap[type] = listenersMap[type].filter(l => l !== listener);
};
const addListener = (type, listener) => {
  let listeners = listenersMap[type];
  if (!listeners) {
    listenersMap[type] = [];
    listeners = listenersMap[type];
  }
  listeners.push(listener);
  return removeListenerFactory(type, listener);
};

// TODO replace with redux-toolkit when it's introduced to the project
export const useMiddlewareListener = (handler, type, deps: any[] = []) => {
  useEffect(() => {
    if (type) {
      return addListener(type, handler);
    }
    return () => null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
